<rask-container-block>
  <div class="row">
    <div class="col-md col-xs-12">
      <fieldset class="form-group">
        <label for="{{aid}}-selectedFromItems" class="col-form-label">{{ itemsTitle }}</label>
        <input type="text" class="form-control input-sm" [(ngModel)]="itemsSearchText" [ngModelOptions]="{standalone: true}">
        <select multiple id="{{aid}}-selectedFromItems" [(ngModel)]="selectedFromItems" [ngModelOptions]="{standalone: true}" (change)="preventEvent($event)"
          (dblclick)="addToTarget()" class="form-control" [size]="size">

          @for (item of items | raskFilter:itemsSearchText; track item) {
            <option [ngValue]="item">
              {{ viewFormatter(item) }}
            </option>
          }
        </select>
      </fieldset>
    </div>
    <div class="col-1 col-xs-12 mx-auto" style="padding-top: 40px">
      <div class="text-center">
        <button type="button" id="{{aid}}-addMaskinlag" (click)="addToTarget()" class="btn btn-tertiary mb-1 str mx-auto">
          <span class="far fa-chevron-right"></span>
        </button>
      </div>
      <div class="text-center">
        <button type="button" id="{{aid}}-removeMaskinlag" (click)="removeFromTarget()" class="btn btn-tertiary stl mx-auto">
          <span class="far fa-chevron-left"></span>
        </button>
      </div>
    </div>
    <div class="col-md col-xs-12">
      <fieldset class="form-group">
        <label for="{{aid}}-selectedFromValue" class="col-form-label">{{ valueTitle }}</label>
        <input type="text" class="form-control input-sm" [(ngModel)]="valueSearchText" [ngModelOptions]="{standalone: true}">
        <select multiple id="{{aid}}-selectedFromValue" [(ngModel)]="selectedFromValue" [ngModelOptions]="{standalone: true}" (change)="preventEvent($event)"
          (dblclick)="removeFromTarget()" class="form-control" [size]="size">

          @for (item of value | raskFilter:valueSearchText; track item) {
            <option [ngValue]="item">
              {{ viewFormatter(item) }}
            </option>
          }
        </select>
      </fieldset>
      <div ngShow="allowValueSort">
        <button type="button" (click)="moveValuePartUp()" class="btn btn-tertiary stl" [disabled]="!canMoveUp()">
          <span class="far fa-chevron-up"></span>
        </button>
        <button type="button" (click)="moveValuePartDown()" class="btn btn-tertiary stl ms-1" [disabled]="!canMoveDown()">
          <span class="far fa-chevron-down"></span>
        </button>
      </div>
    </div>
  </div>
</rask-container-block>
